export default "__VITE_ASSET__14aa31a3__"